import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { alpha } from '@mui/material/styles';

import useContrastTextColor from 'reservations/brand/hooks/useContrastTextColor';

type BaseDividerProps = {
  text?: string;
};

export const BaseDivider = ({ text }: BaseDividerProps) => {
  const color = useContrastTextColor();
  const borderColor = alpha(color, 0.2);

  return (
    <Box sx={{ width: '100%' }} data-testid="base-divider">
      <Divider
        sx={{
          borderColor
        }}
      >
        {text ?? ''}
      </Divider>
    </Box>
  );
};
